'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var SectionHeader = (function (_React$Component) {
    _inherits(SectionHeader, _React$Component);

    function SectionHeader() {
        _classCallCheck(this, SectionHeader);

        _get(Object.getPrototypeOf(SectionHeader.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(SectionHeader, [{
        key: 'render',
        value: function render() {
            var titleProps = {};

            if (!this.props.alwaysOpen) {
                titleProps.href = 'javascript:void(0);';
                titleProps.onClick = this.props.onClick;
            }

            var action = this.props.alwaysOpen || this.props.isOpen ? this.props.children : false,
                collapseIcon = this.props.alwaysOpen ? false : _react2['default'].createElement('a', {
                href: 'javascript:void(0);',
                className: (0, _classnames2['default'])('SectionCollapseIcon', {
                    'SectionCollapseIcon-open': this.props.isOpen
                }),
                onClick: this.props.onClick
            });

            return _react2['default'].createElement(
                'div',
                { className: (0, _classnames2['default'])('SectionHeader'), id: this.props.id },
                _react2['default'].createElement(
                    'h2',
                    _extends({
                        className: (0, _classnames2['default'])('SectionTitle', {
                            'SectionTitle-alwaysOpen': this.props.alwaysOpen
                        })
                    }, titleProps),
                    collapseIcon,
                    this.props.title
                ),
                action
            );
        }
    }]);

    return SectionHeader;
})(_react2['default'].Component);

SectionHeader.propTypes = {
    title: _propTypes2['default'].string,
    alwaysOpen: _propTypes2['default'].bool,
    isOpen: _propTypes2['default'].bool,
    onClick: _propTypes2['default'].func,
    id: _propTypes2['default'].string
};

module.exports = SectionHeader;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/SectionHeader.js
// module id = 381
// module chunks = 0 1